import React, { useEffect, useState, useRef } from 'react';
import { HeroSection } from '../components/landing/HeroSection';
import { PatternSection } from '../components/landing/PatternSection';
import { ConsequencesSection, ProtocolIntroSection, ProgramIncludesSection, AuthorSection, WrittenTestimonialsSection } from '../components/landing/FunnelSections';
import { ProblemSection } from '../components/landing/ProblemSection';
import { SolutionSectionWithCheckout } from '../components/landing/SolutionSectionWithCheckout';
import { BenefitsSection } from '../components/landing/BenefitsSection';
import { BenefitsSectionWithCheckout } from '../components/landing/BenefitsSectionWithCheckout';
import { FAQSection } from '../components/landing/FAQSection';
import { CTASection } from '../components/landing/CTASection';
import { PurchaseNotifier } from '../components/PurchaseNotifier';
import { Lock, Volume2 } from 'lucide-react';
const BASE_CHECKOUT_URL = 'https://pay.hotmart.com/Q104389187Y?off=h96re49q&checkoutMode=10&bid=1771440501662';
const UNLOCK_SECONDS = 30;
export function LandingPage() {
  const secondSectionRef = useRef<HTMLDivElement>(null);
  const [notifierEnabled, setNotifierEnabled] = useState(false);
  const [audioSeconds, setAudioSeconds] = useState(0);
  const [unlocked, setUnlocked] = useState(false);
  const sectionsUnlocked = audioSeconds >= UNLOCK_SECONDS;
  // Once unlocked, stay unlocked
  useEffect(() => {
    if (sectionsUnlocked && !unlocked) {
      setUnlocked(true);
    }
  }, [sectionsUnlocked, unlocked]);
  useEffect(() => {
    if (!unlocked) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setNotifierEnabled(true);
        observer.disconnect();
      }
    }, {
      threshold: 0.1
    });
    if (secondSectionRef.current) {
      observer.observe(secondSectionRef.current);
    }
    return () => observer.disconnect();
  }, [unlocked]);
  const progress = Math.min(audioSeconds / UNLOCK_SECONDS * 100, 100);
  return <main className="min-h-screen bg-gradient-to-b from-orange-50/20 to-yellow-50/20 font-sans text-gray-900" data-id="element-1363">
      <HeroSection ctaUnlocked={unlocked} onAudioProgress={setAudioSeconds} data-id="element-1364" />

      {/* Lock gate — shown below hero until 30s */}
      {!unlocked && <div className="py-16 px-4" style={{
      background: 'linear-gradient(to bottom, #f5f0e8, #ede8df)'
    }} data-id="element-1365">
          <div className="max-w-sm mx-auto rounded-2xl border-2 p-8 text-center shadow-lg" style={{
        backgroundColor: '#ffffff',
        borderColor: '#6DAA7F'
      }} data-id="element-1366">
            <div className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4" style={{
          backgroundColor: '#2F5D50'
        }} data-id="element-1367">
              <Lock className="w-6 h-6 text-white" data-id="element-1368" />
            </div>
            <h3 className="text-base font-extrabold mb-1" style={{
          color: '#2F5D50'
        }} data-id="element-1369">
              Escucha el audio para continuar
            </h3>
            <p className="text-xs text-gray-500 mb-5" data-id="element-1370">
              Necesitas escuchar <strong data-id="element-1371">{UNLOCK_SECONDS} segundos</strong> del
              mensaje de arriba
            </p>
            <div className="w-full bg-gray-200 rounded-full h-2.5 mb-2 overflow-hidden" data-id="element-1372">
              <div className="h-2.5 rounded-full transition-all duration-500" style={{
            width: `${progress}%`,
            background: 'linear-gradient(to right, #2F5D50, #6DAA7F)'
          }} data-id="element-1373" />
            </div>
            <div className="flex items-center justify-between text-xs font-semibold" style={{
          color: '#2F5D50'
        }} data-id="element-1374">
              <span className="flex items-center gap-1" data-id="element-1375">
                <Volume2 className="w-3 h-3" data-id="element-1376" />
                {Math.floor(audioSeconds)}s escuchados
              </span>
              <span data-id="element-1377">{UNLOCK_SECONDS}s requeridos</span>
            </div>
          </div>
        </div>}

      {/* All page content — only rendered after unlock */}
      {unlocked && <div className="animate-fadeIn" data-id="element-1378">
          <PatternSection data-id="element-1379" />
          <ConsequencesSection data-id="element-1380" />
          <ProtocolIntroSection data-id="element-1381" />
          <ProgramIncludesSection data-id="element-1382" />
          <AuthorSection data-id="element-1383" />
          <WrittenTestimonialsSection data-id="element-1384" />
          <div ref={secondSectionRef} data-id="element-1385">
            <BenefitsSectionWithCheckout checkoutUrl={BASE_CHECKOUT_URL} data-id="element-1386" />
          </div>
          <ProblemSection data-id="element-1387" />
          <SolutionSectionWithCheckout checkoutUrl={BASE_CHECKOUT_URL} data-id="element-1388" />
          <FAQSection data-id="element-1389" />
          <CTASection data-id="element-1390" />

          <footer className="bg-orange-50/30 py-12 border-t border-orange-100" data-id="element-1391">
            <div className="container mx-auto px-4 text-center" data-id="element-1392">
              <p className="text-gray-500 text-sm" data-id="element-1393">
                © {new Date().getFullYear()} Recetas Anti-Inflamación para
                Perros. Todos los derechos reservados.
              </p>
              <p className="text-gray-400 text-xs mt-2" data-id="element-1394">
                Este producto es una guía educativa y no sustituye el consejo
                veterinario profesional.
              </p>
            </div>
          </footer>
        </div>}

      <PurchaseNotifier enabled={notifierEnabled} data-id="element-1395" />
    </main>;
}